import { useEffect, useState } from 'react';

import useIsMounted from './useIsMounted';

const IMSMock = {
  isSignedInUser: () => true,
  getAccessToken: () => ({ token: process.env.IMS_TOKEN }),
  getProfile: async () => ({
    email: process.env.IMS_EMAIL,
    displayName: process.env.IMS_DISPLAY_NAME,
  }),
  isMock: true,
};

/* used for dev on localhost without the container */
export const mockedIMSWrapper = {
  initialized: true,
  ...IMSMock,
};

/** Hook used to return the ims instance or a mock */
const useIMS = (props) => {
  const { mock = false } = props ?? {};
  const [isIMSSet, setIsIMSSet] = useState(false);
  // Only return the mocked IMS if the mock flag is set to true
  // This is to ensure that the real app never gets the mocked IMS
  // in actual use, all the test calls to useIMS should have a mock implementation instead
  // If there is another use case for a mocked useIMS, we can use this flag
  /** @type {ReturnType<typeof useState<import('@identity/imslib/adobe-ims/AdobeIMS').AdobeIMS & { isMock?: boolean }>>} */
  const [ims, setIms] = useState(mock ? mockedIMSWrapper : undefined);
  const mounted = useIsMounted();

  useEffect(() => {
    let mounted = true;
    if (isIMSSet) {
      if (mounted && window?.adobeIMS?.initialized) {
        setIms(window.adobeIMS);
      }
    }
    return () => {
      mounted = false;
    };
  }, [isIMSSet]);

  const imsInterval = setInterval(() => {
    if (window.adobeIMS !== undefined && window?.adobeIMS?.initialized) {
      if (mounted.current) {
        setIsIMSSet(true);
      }
      clearInterval(imsInterval);
    }
  }, 100);

  return ims;
};

export default useIMS;
